export const createDebugLogger = (prefix: string, shouldLog?: boolean) =>
  localStorage.getItem('debugModeOn') && shouldLog
    ? console.info.bind(null, prefix)
    : () => {};
